import React from "react";

export default function SectionTitle({ title, subtitle, desc }) {
  return (
    <div className="xl:pl-0 mb-6">
      {subtitle && (
        <p className="text-gradient bg-gradient-to-r from-indigo-500 to-indigo-700 text-sm uppercase font-black tracking-wide text-sm md:text-lg mb-3">
          {subtitle}
        </p>
      )}
      <h1 className="mb-0 text-primary-dark font-sans font-bold md:font-black text-2xl  md:text-4xl">
        {title}
      </h1>
      {desc && (
        <div className="text-gray-600 mt-4 prose lg:prose-lg xl:prose-xl">
          <p>{desc}</p>
        </div>
      )}
    </div>
  );
}
